export default {
  pageNavbar: [
    {
      name: "Home",
      anchor: "home"
    },
    {
      name: "Prezentacja i napęd",
      anchor: "drive-control"
    },
    {
      name: "Kontrola jazdy i bezpieczeństwo",
      anchor: "car-drive"
    },
    {
      name: "Lakiery i akcesoria",
      anchor: "explore"
    },
    {
      name: "Wersje wyposażenia",
      anchor: "versions"
    },
    {
      name: "Elementy Wyposażenia",
      anchor: "equipment"
    },
    {
      name: "Historia",
      anchor: "history"
    }
  ],
  carHeaderLinks: [
    {
      name: "Lakiery i akcesoria",
      position: "right",
      href: "/color-and-accessories"
    },
    {
      name: "Bezpieczeństwo",
      position: "left",
      href: "/safety"
    },
    {
      name: "Wnętrze",
      position: "left",
      href: "/interior"
    },
    {
      name: "Kontrola jazdy",
      position: "left",
      href: "/drive-control"
    },
    {
      name: "Historia",
      position: "left",
      href: "/timeline"
    },
    {
      name: "360",
      position: "left"
    },
    {
      name: "Napęd",
      position: "left",
      href: "/car-drive"
    },
    {
      name: "Multimedia",
      position: "left",
      href: "/audio"
    }
  ],
  interior: "+ Wnętrze",
  section360: "+ 360",
  safety: "+ Bezpieczeństwo",
  firstBoxSubHeader: "Napęd elektryczny i wiele więcej",
  firstBoxHeader: "Teraz możesz znacznie więcej",
  firstBoxDescription: "",
  firstBoxButton: "Napęd",
  secondBoxSubHeader: "Napęd elektryczny i brak ograniczeń",
  secondBoxHeader: "Nieograniczony zasięg w trybie hybrydowym",
  secondBoxDescription:
    "Auto po wyczerpaniu baterii jedzie dalej w trybie hybrydowym wykorzystując swój nowoczesny silnik benzynowy pracujący w cyklu Atkinsona. Nie ma sytuacji w której rozładowane auto stanie się bezużyteczne w momencie, gdy go potrzebujesz. Zawsze dotrzesz do swojego celu.",
  secondBoxButton: "Kontrola jazdy",
  exploreSubHeader: "Napęd elektryczny i SUV coupe",
  exploreHeader: "Więcej do odkrycia. Więcej przyjemności",
  exploreDescription:
    "Jeżeli myślisz, że SUV-y z napędem na 4 koła szkodzą środowisku, hybrydowy Eclipse Cross PHEV sprawi, że zmienisz zdanie. Model oferuje sporą dawkę mocy, właściwe prowadzenie, zdolności terenowe i wszechstronność. Możesz teraz zabrać swoich pasażerów na ciekawą wyprawę terenową! Dzięki specjalnej konstrukcji baterie oraz dodatkowe zespoły napędowe nie ograniczają funkcjonalmości auta, która zapewnia komfortową i super cichą (w trybie EV) podróż dla 5 osób i bagażu bez kompromisów. Jeżdżąc PHEV dbasz o środowisko, w którym żyjesz.",
  exploreButton: "Lakiery i akcesoria",
  historySubHeader: "Napęd elektryczny i  dziedzictwo",
  historyHeader: "Poznaj jego historię",
  historyDescription:
    "Mitsubishi Motors może pochwalić się długą i wspaniałą historią samochodów elektrycznych oraz rajdów, która rozpoczęła się ponad 50 lat temu.",
  historyButton: "Zobacz historię",
  sizeButton: "Wymiary",
  specButton: "Specyfikacja",
  videoButton: "Zobacz prezentację",
  sliderHeader: "Wersje wyposażenia",
  equipmentHeaderSub: "Sprawdź",
  equipmentHeader: "Wybrane elementy wyposażenia",
  gallerySlider: [
    {
      header: "Podgrzewana kierownica",
      desc: " ",
      image: "gallery-1.jpg"
    },
    {
      header: "Podgrzewane przednie fotele i tylna kanapa",
      desc: " ",
      image: "gallery-2.jpg"
    },
    {
      header: "Łopatki systemu hamowania odzyskowego",
      desc: " ",
      image: "gallery-3.jpg"
    },
    {
      header: "Podsufitka w kolorze czarnym",
      desc: " ",
      image: "gallery-4.jpg"
    }
  ],
  slider: [
    {
      name: "Intense Plus (SA8)",
      images: ["carie_02.png", "car2ie.png"],
      interior: [
        "21MY_EP_DEU_INTENSE-U02_4WD_seat_synthetic-leather_black.jpg",
        "21MY_EP_DEU_INTENSE-U02_4WD_seat_synthetic-leather_black.png"
      ],
      specs: [
        [
          "Felgi aluminiowe 18-calowe z oponami 225/55 R18",
          "Przednie reflektory w technologii Bi-LED",
          "Światła do jazdy dziennej w technologii LED",
          "Elektrycznie sterowane, podgrzewane i składane lusterka zewnętrzne",
          "Elektryczny hamulec postojowy z funkcją Auto Hold",
          "Skórzane obszycie kierownicy"
        ],
        [
          "Częściowo skórzana tapicerka foteli",
          "Elektrycznie regulowany fotel kierowcy",
          "Tempomat adaptacyjny",
          "Automatyczna klimatyzacja dwustrefowa",
          "Podgrzewane fotele przednie i tylna kanapa",
          "Podgrzewana kierownica"
        ],
        [
          "Stacja multimedialna SDA  z ekranem dotykowym o przekątnej 8-cali",
          "Interfejs Android Auto i Apple CarPlay",
          "System kontroli trakcji i stabilizacji toru jazdy (ASTC)",
          "System kamer 360 stopni",
          "Przednie i tylne czujniki parkowania",
          "Czołowe, boczne i kurtynowe poduszki powietrzne"
        ],
        [
          "Kolanowa poduszka powietrzna kierowcy",
          "System ograniczający skutki kolizji czołowych (FCM)",
          "System ostrzegający o niezamierzonej zmianie pasa ruchu (LDW)",
          "System monitorowania martwego pola (BSW)",
          "System monitorowania ruchu poprzecznego podczas jazdy do tyłu (RCTA)"
        ]
      ]
    },
    /*
    {
      name: "Instyle",
      images: ["car_02.png", "car2_02.png"],
      interior: ["20MY_PH_EU_LHD_INSTYLE_IP_190523.jpg", "20MY_PH_EU_LHD_INSTYLE_SEAT_190523.jpg"],
      specs: [
        [
          "Felgi aluminiowe 18-cali z oponami 225/55R18",
          "Przednie reflektory w technologii Bi-LED (światła mijania i drogowe)",
          "Przednie reflektory przeciwmgielne w technologii LED"
        ],
        [
          "Fotel kierowcy regulowany elektrycznie",
          "Elektryczne ogrzewanie kabiny",
          "Stacja multimedialna SDA z ekranem dotykowym 8-cali i interfejsem Android Auto/Apple Car Play"
        ],
        [
          "Przednie i tylne czujniki parkowania",
          "System monitorowania martwego pola w lusterkach zewnętrznych (BSW)",
          "System monitorowania ruchu poprzecznego podczas jazdy do tyłu (RCTA)"
        ],
        [
          "Tekstylna tapicerka foteli w kolorze czarnym łączona z syntetyczną skórą",
          "2x gniazdo USB dla II rzędu siedzeń"
        ]
      ]
    },
    */
    {
      name: "Instyle Plus (SB3)",
      images: ["instyle-plus-front.png", "instyle-plus-back.png"],
      interior: ["INSTYLE-PLUS-SB3-black.jpg", "INSTYLE-PLUS-SB3-white.jpg"],
      specs: [
        [
          "Felgi aluminiowe 18-calowe z oponami 225/55 R18",
          "Przednie reflektory w technologii Bi-LED",
          "Światła do jazdy dziennej w technologii LED",
          "Elektrycznie sterowane, podgrzewane i składane lusterka zewnętrzne",
          "Elektryczny hamulec postojowy z funkcją Auto Hold",
          "Skórzane obszycie kierownicy",
          "Wyświetlacz przezierny HUD (Head-up Display)"
        ],
        [
          "Skórzana tapicerka w foteli w kolorze czarnym lub jasnoszarym",
          "Elektrycznie regulowany fotel kierowcy i pasażera",
          "Tempomat adaptacyjny",
          "Automatyczna klimatyzacja dwustrefowa",
          "Podgrzewane fotele przednie i tylna kanapa",
          "Podgrzewana kierownica",
          "System nawigacji dla stacji multimedialnej SDA"
        ],
        [
          "Stacja multimedialna SDA  z ekranem dotykowym o przekątnej 8-cali",
          "Interfejs Android Auto i Apple CarPlay",
          "System kontroli trakcji i stabilizacji toru jazdy (ASTC)",
          "System kamer 360 stopni",
          "Przednie i tylne czujniki parkowania",
          "Czołowe, boczne i kurtynowe poduszki powietrzne",
          "System nagłośnienia Mitsubishi Power Sound System"
        ],
        [
          "Kolanowa poduszka powietrzna kierowcy",
          "System ograniczający skutki kolizji czołowych (FCM)",
          "System ostrzegający o niezamierzonej zmianie pasa ruchu (LDW)",
          "System monitorowania martwego pola (BSW)",
          "System monitorowania ruchu poprzecznego podczas jazdy do tyłu (RCTA)",
          "Podgrzewana szyba czołowa"
        ]
      ]
    }
  ]
};
